import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { storyblokInit, apiPlugin } from "@storyblok/react";

import App from "./App";
import "./index.css";

// Component imports
import Page from "./components/Page";
import HeroSection from "./components/HeroSection";
import IconRow from "./components/IconRow";
import IconItem from "./components/IconItem";
import FiftyFifty from "./components/FiftyFifty";
import TitleParagraphImage from "./components/TitleParagraphImage";
import Accordion from "./components/Accordion";
import AccordionItem from "./components/AccordionItem";
import MediaFeature from "./components/MediaFeature";
import QuoteFeature from "./components/QuoteFeature";
import ResourcesCards from "./components/ResourcesCards";
import ResourceCard from "./components/ResourceCard";
import Menu from "./components/Menu";
import Carousel from "./components/Carousel";
import CarouselFeature from "./components/CarouselFeature";
import CarouselSlide from "./components/CarouselSlide";
import ContactBanner from "./components/ContactBanner";
import LargeImageCard from "./components/LargeImageCard";
import LargeImageCardItem from "./components/LargeImageCardItem";
import DevicesFiftyFifty from "./components/DevicesFiftyFifty";
import PortalCard from "./components/PortalCard";
import PortalCardRow from "./components/PortalCardRow";
import Header from "./components/Header";
import LargeTextCardRow from "./components/LargeTextCardRow";
import LargeTextCard from "./components/LargeTextCard";
import SecurityFeature from "./components/SecurityFeature";
import Chart from "./components/Chart";
import ChartRow from "./components/ChartRow";
import ChartCell from "./components/ChartCell";
import Footer from "./components/Footer";
import ContactUsForm from "./components/ContactUsForm";
import ContactUsHero from "./components/ContactUsHero";
import SupportFeature from "./components/SupportFeature";
import SimpleTable from "./components/SimpleTable";
import SimpleTableRow from "./components/SimpleTableRow";

storyblokInit({
  accessToken: process.env.REACT_APP_STORYBLOK_TOKEN,
  use: [apiPlugin],
  components: {
    page: Page,
    hero_section: HeroSection,
    icon_row: IconRow,
    icon_item: IconItem,
    fifty_fifty: FiftyFifty,
    title_paragraph_image: TitleParagraphImage,
    accordion: Accordion,
    accordion_item: AccordionItem,
    media_feature: MediaFeature,
    quote_feature: QuoteFeature,
    resources_cards: ResourcesCards,
    resource_card: ResourceCard,
    menu: Menu,
    carousel: Carousel,
    carousel_feature: CarouselFeature,
    carousel_slide: CarouselSlide,
    contact_banner: ContactBanner,
    large_image_card: LargeImageCard,
    large_image_card_item: LargeImageCardItem,
    devices_fifty_fifty: DevicesFiftyFifty,
    portal_card: PortalCard,
    portal_card_row: PortalCardRow,
    header: Header,
    large_text_card_row: LargeTextCardRow,
    large_text_card: LargeTextCard,
    security_feature: SecurityFeature,
    chart: Chart,
    chart_row: ChartRow,
    chart_cell: ChartCell,
    footer: Footer,
    contact_us_form: ContactUsForm,
    contact_us_hero: ContactUsHero,
    support_feature: SupportFeature,
    simple_table: SimpleTable,
    simple_table_row: SimpleTableRow,
  },
  // apiOptions: {
  // If the space is in the US, use "us". Otherwise remove apiOptions entirely.
  // region: "us",
  // },
  // I'm commenting apiOptions out for now since the Storyblok space is set to EU.
});

const container = document.getElementById("app");
createRoot(container).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

